<!--  -->
<template>
  <div>
    <!-- 下拉菜单 -->
    <nav-header></nav-header>
    <!-- 头部 -->
    <div class="headerBox">
      <div class="optBox">
        <van-icon name="wap-nav" class="menuBox" @click="showMenu()" />
        <div class="logoImg">
          <img src="../assets/logo.png" alt />
        </div>
        <div class="bigTitle">联系我们</div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="contentBox">
      <div class="contentTitle">{{companyMsg.name}}</div>
      <ul>
        <li>
          <p>地址：{{companyMsg.address}}</p>
        </li>
        <li>
          <p>电话：{{companyMsg.phone}}</p>
        </li>
        <li>
          <p>邮编：{{companyMsg.postcode}}</p>
        </li>
        <li>
          <p>7动盆底肌微信公众号(女生)：{{companyMsg.wxGirl}}</p>
        </li>
        <li>
          <p>7动盆底肌微信公众号(男生)：{{companyMsg.wxBoy}}</p>
        </li>
        <li>
          <p>7动官方微博：{{companyMsg.weibo}}</p>
        </li>
        <li>
          <p>网站服务：{{companyMsg.email}}</p>
        </li>
        <li>
          <p>合作商务：{{companyMsg.hezuo}}</p>
        </li>
      </ul>
    </div>
    <div class="mapBox">
      <div id="container" style="width: 90%;height: 15rem;margin: auto;"></div>
    </div>
    <nav-footer></nav-footer>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NavFooter from "@/mobile/common/footer.vue";
import NavHeader from "@/mobile/common/header.vue";
import { companyMsg } from "@/components/data.js";
import maps from "qqmap";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    NavFooter,
    NavHeader
  },
  data() {
    //这里存放数据
    return {
      companyMsg: companyMsg
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    showMenu() {
      var animation = function() {
        let animationClass = "slipShow";
        var ele = document.getElementById("menuBox");
        ele.className = "menuShow " + animationClass;

        // ele = document.getElementById("dialog");
        // ele.className = "msgBox " + animationClass;
      };

      setTimeout(animation, 100);
    },
    hideMenu() {
      var animation = function() {
        let animationClass = "slipHide";
        var ele = document.getElementById("menuBox");
        ele.className = "menuShow " + animationClass;

        // ele = document.getElementById("dialog");
        // ele.className = "msgBox " + animationClass;
      };

      setTimeout(animation, 100);
    },
    init() {
      var that = this;
      maps.init("WWKBZ-R6AR3-FMD34-3KGGH-XY357-66B2G", () => {
        var myLatlng = new qq.maps.LatLng(22.546146, 113.886078);
        var myOptions = {
          zoom: 16,
          center: myLatlng,
          mapTypeId: qq.maps.MapTypeId.ROADMAP,
          mapStyleId: "style3"
        };
        that.map = new qq.maps.Map(
          document.getElementById("container"),
          myOptions
        );

        var marker = new qq.maps.Marker({
          position: myLatlng,
          map: that.map
        });
        var marker = new qq.maps.Label({
          position: myLatlng,
          map: that.map,
          content: "金矿网络科技有限公司"
        });
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var timer = setInterval(function() {
      let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      let ispeed = Math.floor(-osTop / 5);
      document.documentElement.scrollTop = document.body.scrollTop =
        osTop + ispeed;
      this.isTop = true;
      if (osTop === 0) {
        clearInterval(timer);
      }
    }, 30);
    this.init()
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.bigTitle {
  text-align: center;
  color: #fff;
  font-size: 2rem;
  letter-spacing: 2px;
  margin-top: 1rem;
  font-weight: 400;
}
.headerBox {
  background-image: url("../assets/contact.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  height: 10rem;
  width: 100%;
}
.optBox {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.logoImg {
  width: 5rem;
  margin: auto;
  padding-top: 1rem;
}
img {
  width: 100%;
  height: 100%;
}
.menuBox {
  color: #fff;
  font-size: 2rem;
  position: absolute;
  top: 1rem;
  left: 1rem;
}
.menuShow {
  position: fixed;
  background: rgba(0, 0, 0, 1);
  z-index: 3;
  width: 100%;
}
.menuList a {
  color: #fff;
}
.menuList ul > li {
  text-align: center;
  width: 100%;
  height: 3rem;
  border-bottom: 1px solid #1f1f1f;
  line-height: 3rem;
  font-size: 0.8rem;
}
.menuList ul > li > a {
  display: block;
}
/* 动画 */
.none {
  display: none;
}
.menuShow {
  position: fixed;
  z-index: 2000;
  left: 50%;

  -webkit-animation-duration: 500ms;
  -moz-animation-duration: 500ms;
  -o-animation-duration: 500ms;
  animation-duration: 500ms;
  -webkit-perspective: 1300px;
  -moz-perspective: 1300px;
  perspective: 1300px;
}

.menuShow.slipShow {
  top: 6rem;
  opacity: 1;

  -webkit-animation-name: dialogSlipToUp;
  -moz-animation-name: dialogSlipToUp;
  -o-animation-name: dialogSlipToUp;
  animation-name: dialogSlipToUp;
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  /* 实现水平垂直居中 */
  transform: translate(-50%, -50%);
}

.menuShow.slipHide {
  top: 100%;
  opacity: 0.3;
  -webkit-animation-duration: 500ms;
  -moz-animation-duration: 500ms;
  -o-animation-duration: 500ms;
  animation-duration: 500ms;
  -webkit-animation-name: dialogSlipToBottom;
  -moz-animation-name: dialogSlipToBottom;
  -o-animation-name: dialogSlipToBottom;
  animation-name: dialogSlipToBottom;
  -webkit-transform: translate(-50%, 0);
  -o-transform: translate(-50%, 0);
  -moz-transform: translate(-50%, 0);
  -ms-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}

@keyframes showMenuBox {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
@keyframes hideMenuBox {
  0% {
    opacity: 0.7;
    visibility: visible;
  }

  100% {
    visibility: hidden;
    opacity: 0;
  }
}
@keyframes dialogSlipToUp {
  0% {
    top: 0;
    opacity: 0.3;
  }

  100% {
    top: 15%;
    opacity: 1;
  }
}
@keyframes dialogSlipToBottom {
  0% {
    top: 15%;
    opacity: 1;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  100% {
    top: -15%;
    opacity: 0.3;
    -webkit-transform: translate(-50%, 0);
    -moz-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
  }
}

.contentBox {
  width: 85%;
  margin: auto;
  margin-top: 2rem;
}
.contentTitle {
  color: #3caff3;
  font-size: 16px;
  margin: 30px 0;
}
p {
  text-align: justify;
  line-height: 1.8rem;
  padding-bottom: 20px;
  font-size: 0.9rem;
  font-weight: 300;
}
</style>


// WEBPACK FOOTER //
// src/mobile/contact.vue